module.exports = __webpack_public_path__ + "static/img/happy-waving.738ce4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guider/happy-waving.png
// module id = 7mt7
// module chunks = 1